import React from "react"
import {Container} from "./component"

export type MiniShoppingBagCheckoutClubProps = {
    children: React.ReactNode
}

export const MiniShoppingBagCheckout = (props: MiniShoppingBagCheckoutClubProps) => {
    const {children} = props
    return (
        <Container data-testid="minibag-adaptive-checkout" className="header-adaptive-checkout">
            {children}
        </Container>
    )
}

export default MiniShoppingBagCheckout
